module.exports = __webpack_public_path__ + "static/media/starfighter.a8c3a7d8.svg";